import { render, staticRenderFns } from "./T4i.vue?vue&type=template&id=3bf26918&scoped=true&"
import script from "./T4i.vue?vue&type=script&lang=js&"
export * from "./T4i.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf26918",
  null
  
)

export default component.exports